import * as files from '../svgs'

// Calculate SVGS.RATIO //
// Percentage of svg h:w
// height: Int, width: Int
// You can find the h & w in the svg `viewbox` attr
const getRatio = (height, width) => {
  return `${(height / width) * 100}%`
}

export const SVGS = {
  CART: {
    RATIO: getRatio(1, 1),
    SVG: files.cart(),
  },
  LOGO: {
    RATIO: getRatio(1, 1),
    SVG: files.logo(),
  },
  SIMPLE_LOGO: {
    RATIO: getRatio(1, 1),
    SVG: files.simpleLogo(),
  },
  SIMPLE_LOGO_SOLID: {
    RATIO: getRatio(1, 1),
    SVG: files.simpleLogoSolid(),
  },
  INSTAGRAM: {
    RATIO: getRatio(1, 1), // '100%'
    SVG: files.instagram(),
  },
  EMAIL: {
    RATIO: getRatio(1, 1), // '100%'
    SVG: files.email(),
  },
  YOUTUBE: {
    RATIO: getRatio(1, 1), // '100%'
    SVG: files.youtube(),
  },
}
